
<img v-if="src" class="inline-icon" v-svg-inline :src="src" :class="{ 'hidden-box': !src }" />
